import React, { useState } from "react";
import "./styles/registration-form.css";
import emailjs from "emailjs-com";

const RegistrationForm = () => {
    const [formData, setFormData] = useState({
        country: "",
        fullName: "",
        accountOwnerName: "",
        email: "",
        phone: "",
        businessName: "",
        contactPerson: "",
        businessAddress: "",
        businessType: "",
        referral: "",
        comments: "",
        agreeTerms: false,
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.agreeTerms) {
            alert("Please agree to the Terms and Conditions");
            return;
        }

        emailjs
            .send(
                "service_p87ckej",
                "template_n8vitb5",
                formData,
                "VfZHrEohvKZLPH_7V",
            )
            .then(() => {
                alert(
                    "Form submitted successfully! We will contact you within 48 hours.",
                );
                setFormData({
                    country: "",
                    fullName: "",
                    accountOwnerName: "",
                    email: "",
                    phone: "",
                    businessName: "",
                    contactPerson: "",
                    businessAddress: "",
                    businessType: "",
                    referral: "",
                    comments: "",
                    agreeTerms: false,
                });
            })
            .catch((error) => {
                console.error("EmailJS error:", error);
                alert(error.text || "Erro desconhecido");
            });
    };

    return (
        <section className="registration-section" id="register">
            <div className="container">
                <div className="form-intro">
                    <h2>Become a Customer</h2>
                    <p>
                        Please complete this form to become a customer of
                        Precise Prep. Once submitted, you will receive a
                        personalized spreadsheet sent directly to your e-mail in
                        up to 48 hours. This tool makes it simple and convenient
                        to track all your orders and shipments, keeping
                        everything organized in one place. We look forward to
                        working with you!
                    </p>
                </div>

                <div className="registration-form">
                    <h3 className="section-title">Registration Information</h3>

                    <div className="form-group">
                        <label htmlFor="country">Country of Residence *</label>
                        <input
                            type="text"
                            id="country"
                            name="country"
                            value={formData.country}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="fullName">
                                First and Last Name *
                            </label>
                            <input
                                type="text"
                                id="fullName"
                                name="fullName"
                                value={formData.fullName}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="accountOwnerName">
                                Account Owner's Full Name (if different)
                            </label>
                            <input
                                type="text"
                                id="accountOwnerName"
                                name="accountOwnerName"
                                value={formData.accountOwnerName}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="email">Contact E-mail Address *</label>
                        <small>
                            Gmail preferred, for invoicing, communication, and
                            spreadsheet access
                        </small>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="phone">
                                Contact Phone Number *
                            </label>
                            <input
                                type="tel"
                                id="phone"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="businessName">
                                Business Name *
                            </label>
                            <input
                                type="text"
                                id="businessName"
                                name="businessName"
                                value={formData.businessName}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="contactPerson">Contact Person *</label>
                        <input
                            type="text"
                            id="contactPerson"
                            name="contactPerson"
                            value={formData.contactPerson}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="businessAddress">
                            Business Full Address *
                        </label>
                        <textarea
                            id="businessAddress"
                            name="businessAddress"
                            value={formData.businessAddress}
                            onChange={handleChange}
                            rows="3"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="businessType">
                            Which best describes your business? *
                        </label>
                        <select
                            id="businessType"
                            name="businessType"
                            value={formData.businessType}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Select an option</option>
                            <option value="online-arbitrage">
                                Online Arbitrage
                            </option>
                            <option value="retail-arbitrage">
                                Retail Arbitrage
                            </option>
                            <option value="wholesale">Wholesale</option>
                            <option value="private-label">Private Label</option>
                        </select>
                    </div>

                    <div className="form-group">
                        <label htmlFor="referral">
                            How did you hear about us?
                        </label>
                        <small>e.g., name of the person who referred you</small>
                        <input
                            type="text"
                            id="referral"
                            name="referral"
                            value={formData.referral}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="comments">
                            Comments and Suggestions
                        </label>
                        <textarea
                            id="comments"
                            name="comments"
                            value={formData.comments}
                            onChange={handleChange}
                            rows="4"
                        />
                    </div>

                    <div className="terms-section">
                        <h3 className="section-title">Terms and Conditions</h3>
                        <div className="terms-content">
                            <ol>
                                <li>
                                    Once this form is received, we will provide
                                    our warehouse address for you to forward
                                    your inventory.
                                </li>
                                <li>
                                    Ship your inventory to Precise Prep
                                    Services.
                                </li>
                                <li>
                                    Our base fee includes inventory receiving,
                                    item inspection, photos provided when issues
                                    are identified, labeling and packing, and
                                    drop-off with carriers such as UPS, USPS,
                                    FedEx, and others.
                                </li>
                                <li>
                                    Additional preparation services may have
                                    varying prices depending on your needs.
                                </li>
                                <li>
                                    You are responsible for all shipping costs.
                                </li>
                                <li>
                                    <strong>Warning:</strong> We do not work
                                    with removal orders, returns, or fragile
                                    products without secure packaging from the
                                    supplier.
                                </li>
                                <li>
                                    <strong>Payment:</strong> Billing will be
                                    processed automatically once your shipment
                                    is ready. Orders will only be processed and
                                    released after full payment is received.
                                </li>
                                <li>
                                    You will receive e-mail notifications
                                    regarding any changes in fees or terms.
                                </li>
                                <li>
                                    Books or items exceeding 20 inches on the
                                    longest side are not accepted.
                                </li>
                                <li>
                                    Precise Prep is not liable for items lost or
                                    misplaced by Amazon or carriers.
                                </li>
                                <li>
                                    Items not listed in your Google spreadsheet
                                    inventory will be disposed of after 30 days
                                    of no communication.
                                </li>
                                <li>
                                    Gated or restricted items in your Amazon
                                    account will be disposed of after 30 days of
                                    no communication.
                                </li>
                                <li>
                                    Clients may include up to three (3)
                                    authorized recipient names for incoming
                                    shipments, or shipments may be addressed
                                    directly to Precise Prep Services. Packages
                                    received under any other name will be
                                    refused and returned to the carrier.
                                </li>
                                <li>
                                    All shipping labels must fully comply with
                                    the requirements of the selected carrier. If
                                    a label is found to be incorrect,
                                    incomplete, or non-compliant, the shipment
                                    will be placed on hold and will not be
                                    shipped until a corrected label is provided
                                    by the client.
                                </li>
                                <li>
                                    Precise Prep guarantees our work. Fee
                                    reimbursements for mislabeled products
                                    caused by our facility will be provided only
                                    upon return of the items to Precise Prep,
                                    with pictures showing the mislabeling. No
                                    reimbursement will be made if the error is
                                    caused by Amazon.
                                </li>
                                <li>
                                    Address Usage Policy - Under no
                                    circumstances may our address be used to
                                    register accounts with Amazon, eBay, FedEx,
                                    any shipping carrier, or any other platform
                                    or service. Our address may be used solely
                                    as a return address on shipping labels, if
                                    necessary. Any violation of this policy may
                                    result in suspension or termination of your
                                    account.
                                </li>
                                <li>
                                    Non-Payment and Unresponsive Accounts: If an
                                    invoice remains unpaid and/or the client fails
                                    to respond to communications for more than 30
                                    consecutive days, Precise Prep Services will
                                    send a formal notice via email (and, if
                                    available, another contact method on file)
                                    informing the client of the outstanding
                                    balance and the inventory being held. The
                                    client will have 15 additional days from the
                                    date of this notice to pay the balance in full
                                    or arrange for return/pickup of the inventory
                                    at their own cost. If no response or payment
                                    is received within this period, Precise Prep
                                    Services reserves the right, to the fullest
                                    extent permitted by Florida law (including
                                    Fla. Stat. § 677.209 and § 677.210), to sell,
                                    liquidate, or dispose of the inventory to
                                    recover the outstanding balance and any
                                    associated costs. Any proceeds from a sale
                                    exceeding the amount owed, after deducting
                                    reasonable expenses, will be remitted to the
                                    client if a valid claim is made within a
                                    reasonable time. This clause applies
                                    independently of, and in addition to, items 11
                                    and 12 above.
                                </li>
                                <li>
                                    Storage Fee: The first 30 days of storage are
                                    free of charge for all clients. Starting on
                                    day 31, storage fees will apply based on the
                                    type of inventory stored at our facility,
                                    regardless of account activity status, until
                                    the inventory is shipped out, picked up, or
                                    otherwise resolved: Box (up to 24x24x24 in):
                                    $15.00/month Pallet: $25.00/month
                                </li>
                            </ol>
                        </div>

                        <div className="form-group checkbox-group">
                            <label className="checkbox-label">
                                <input
                                    type="checkbox"
                                    name="agreeTerms"
                                    checked={formData.agreeTerms}
                                    onChange={handleChange}
                                    required
                                />
                                <span>
                                    I have read and agree with the Terms and
                                    Conditions *
                                </span>
                            </label>
                        </div>
                    </div>

                    <button onClick={handleSubmit} className="submit-button">
                        Submit Registration
                    </button>
                </div>
            </div>
        </section>
    );
};

export default RegistrationForm;
